const getMasterVideoFromEntry = entry => {
  if (entry.heroImageSet && entry.heroImageSet.masterCinemagraph) {
    return {
      src: entry.heroImageSet.masterCinemagraph.url,
    }
  }

  if (entry.__typename === 'Store' && entry.retailer) {
    return getMasterVideoFromEntry(entry.retailer)
  }

  return {
    src: null,
  }
}

export default getMasterVideoFromEntry
